import { Component, EventEmitter, Input, Output } from '@angular/core';
import { VentaRapidaUser } from 'src/app/models/venta-rapida/venta-rapida-user.model';

@Component({
  selector: 'app-user-search-result-item',
  templateUrl: './user-search-result-item.component.html',
  styleUrls: ['./user-search-result-item.component.scss'],
  standalone: false
})
export class UserSearchResultItemComponent {
  @Input({ required: true }) user!: VentaRapidaUser;
  @Output() selected = new EventEmitter<VentaRapidaUser>();

  onClick(): void {
    this.selected.emit(this.user);
  }

  get dniDisplay(): string {
    return this.user.dni?.trim() ? this.user.dni : 'DNI: ---';
  }

  get emailDisplay(): string {
    return this.user.email?.trim() ? this.user.email : 'Sin email';
  }
}
